import { render } from "./NotificacaoErro.vue?vue&type=template&id=7cc26330&scoped=true"
import script from "./NotificacaoErro.vue?vue&type=script&lang=js"
export * from "./NotificacaoErro.vue?vue&type=script&lang=js"

import "./NotificacaoErro.vue?vue&type=style&index=0&id=7cc26330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc26330"]])

export default __exports__